import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { endPoints } from "api/endPoints";
import { RootState } from "store/rootReducer";
import { HTTPMSG } from "config";
import { IOffers } from "features/offers/offers.interface";
import { API } from "api/api";

interface OfferListingState {
  offerData: IOffers | null;
  loading: boolean;
  error: boolean;
  errorMessage: string;
}

const initialData: IOffers | null = null;

export const initialState: OfferListingState = {
  offerData: initialData,
  loading: false,
  error: false,
  errorMessage: "",
};

const fetchOfferDetailsAPI = (slug: string) => {
  return new Promise((resolve, reject) => {
    if (slug) {
      API.get(endPoints.OFFERS.OFFER_DETAILS(slug))
        .then((response) => resolve(response))
        .catch((error) => {
          console.error("Error fetching offer:", error);
          reject(error);
        });
    }
  });
};

export const fetchOfferDetails: any = createAsyncThunk(
  "offerListing/fetchOfferDetails",
  async (slug: string, { rejectWithValue }) => {
    try {
      const response: any = await fetchOfferDetailsAPI(slug);
      return response.data;
    } catch (e: any) {
      return rejectWithValue(e.response?.data || e);
    }
  }
);

const offerListingSlice = createSlice({
  name: "offerListing",
  initialState,
  reducers: {
    clearOfferData: (state) => {
      state.offerData = null;
      state.error = false;
      state.errorMessage = "";
    },
  },
  extraReducers: {
    [fetchOfferDetails.pending]: (state) => {
      state.loading = true;
      state.error = false;
    },
    [fetchOfferDetails.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = HTTPMSG[payload?.message || "ERROR"];
    },
    [fetchOfferDetails.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.offerData = payload.data;
    },
  },
});

export const { clearOfferData } = offerListingSlice.actions;

export const offerListingSelector = (state: RootState) => state.offerListing;

export default offerListingSlice.reducer;
